import React from "react";
import { styled } from "@linaria/react";
import { css } from "@linaria/core";
import { StaticImage } from "gatsby-plugin-image";

const Links = styled.div`
  display: flex;
  gap: 1.25rem;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    justify-content: space-between;
  }
`;

const linkStyle = css`
  height: 25px;
  aspect-ratio: 1;
  transition: all 250ms;
  @media (max-width: 375px) {
    height: 15px;
  }
`;

const SocialLinks = () => {
  const links = [
    <StaticImage
      src="./img/social/fb-logo.png"
      href="https://www.facebook.com/rhombus/"
      className={linkStyle}
      alt="facebook logo"
      loading="lazy"
    />,
    <StaticImage
      src="./img/social/ig-logo.png"
      href="https://www.instagram.com/rhombus_hq/"
      className={linkStyle}
      alt="instagram logo"
      loading="lazy"
    />,
    <StaticImage
      src="./img/social/in-logo.png"
      href="https://www.linkedin.com/company/rhombus-systems"
      className={linkStyle}
      alt="linkedin logo"
      loading="lazy"
    />,
    <StaticImage
      src="./img/social/yt-logo.png"
      href="https://www.youtube.com/channel/UC1vFNrCK_4AkCWVcjVc9LTg"
      className={linkStyle}
      alt="youtube logo"
      loading="lazy"
    />,
  ];

  return (
    <Links>
      {links.map((component) => (
        <a href={component.props.href} target="_blank">
          {component}
        </a>
      ))}
    </Links>
  );
};

export default SocialLinks;
